export class FetchUserAction {
  static readonly type = '[User] Fetch User';

  constructor() {
  }
}
